import { render, staticRenderFns } from "./TestForm.vue?vue&type=template&id=66c3bbf2&scoped=true"
import script from "./TestForm.vue?vue&type=script&lang=js"
export * from "./TestForm.vue?vue&type=script&lang=js"
import style0 from "./TestForm.vue?vue&type=style&index=0&id=66c3bbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3bbf2",
  null
  
)

export default component.exports